import Layout from "@/components/Layout";
import PageHero from "@/components/PageHero";
import AboutMe from "@/components/AboutMe";
import NextPageCta from "@/components/NextPageCta";

export default function MyStoryPage() {
  return (
    <Layout>
      <PageHero
        eyebrow="My Story"
        title="The story behind"
        italic="the standards."
        blurb="From the agency floor doing lets and sales, to full developments under a mentor's wing in London — and now back home in Warwickshire."
      />
      <AboutMe />
      <NextPageCta to="/work" label="See the work →" sub="Before & afters from real properties across the West Midlands." />
    </Layout>
  );
}
